import { render } from "./App.vue?vue&type=template&id=e1738110"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e1738110&lang=sass"
script.render = render

export default script